import React, { useEffect, useState } from 'react';
import { Col } from '@gjensidige/core-grid';
import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { ROUTES } from '../lib/constants';
import { updatePurchaseStatus } from '../store/slices/offerSlice';
import tracker from '../tracking';
import { CommonCoverageList } from '../components/CoverageList/CommonCoverageList';
import { Package } from '../interfaces/Types';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { TextHelper } from '../utils/TextHelper';
import { TrackingHelper } from '../utils/TrackingHelper';
import { EnquiryContainer } from './EnquiryContainer';
import { InsuranceDocumentsContainer } from './InsuranceDocumentsContainer';

export const SingleInsurancePackageContainer: React.FC = () => {
  const packages = useAppSelector((state) =>
    state.insurance.packages.filter((item: Package) => !item.isPlusPackage)
  );
  const { productName, productCode, policyNumber } = useAppSelector(
      (state) => state.insurance.offer
  );

  const channel = InsuranceHelper.getChannelInfo();
  const dispatch = useAppDispatch();
  const selectedPackage =
    InsuranceHelper.getSelectedPackageFromConfig(packages);

  useEffect(() => {
    const stepStatus = TextHelper.getHeaderStepLabels(
      productName,
      ROUTES.offerPage
    );
    dispatch(updatePurchaseStatus(stepStatus));
    if (packages.length > 0) {
      const trackOptions = {
        event_name: TrackingHelper.getEventNameToTrackOnOfferLoad(productName),
        product_name: TrackingHelper.getProductListToTrack(productName),
        product_brand: ['insurance'],
        product_category: [
          TrackingHelper.getProductCategoryToTrack(productName)
        ],
        product_sku: [productCode],
        scenario_name: TrackingHelper.getScenarioNameFromProduct(productName),
        scenario_step: 'choose-plan',
        scenario_type: TrackingHelper.isFollowUpOffer(policyNumber) ? 'follow-up-offer' : ''
      };
      tracker.setOptions(trackOptions);
      tracker.trackScenerioStep(
        'offer',
        TrackingHelper.getScenarioNameFromProduct(productName),
        'choose-plan'
      );
    }
  }, []);

  const fullCoverageList = InsuranceHelper.getFullListOfCoverages(packages);
  const [selectedCoverage, setSelectedCoverage] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const expandSections = (coverage: string) => {
    setSelectedCoverage(coverage);
  };

  return (
    <>
      {packages.length > 0 && 
        <>
          <Col
            sm="12"
            md={{ span: 8, offset: 2 }}
            lg={{ span: 8, offset: 2 }}
            xl={{ span: 6, offset: 3 }}
          >
            <div>
              <EnquiryContainer stepCode="000" isVerticalGroup wrapperClassName="full-width"/>
            </div>
            <div className="deductible-wrapper mt-5">
              <EnquiryContainer stepCode="001" isVerticalGroup wrapperClassName="full-width"/>
            </div>           
            <div className="mt-5">
              <EnquiryContainer stepCode="002" isVerticalGroup wrapperClassName="full-width"/>
            </div>
            <div className="mt-5">
              <EnquiryContainer stepCode="003" isVerticalGroup wrapperClassName="full-width"/>
            </div>
            <div className="mt-5">
              <EnquiryContainer stepCode="004" isVerticalGroup wrapperClassName="full-width"/>
            </div>
            <div>
              <CommonCoverageList 
                fullCoverageList={fullCoverageList}
                expandSections={expandSections}
                selectedCoverage={selectedCoverage}
                setIsExpanded={setIsExpanded}
                isExpanded={isExpanded}
                productName={productName}
                commonCoverageClass='single-coverage-list'
              />
            </div>
          </Col>
          <Col
            sm="12"
            md={{ span: 8, offset: 2 }}
            lg={{ span: 8, offset: 2 }}
            xl={{ span: 3, offset: 0 }}
          >
            <div className={`offer-page-docs-${productName}`}><InsuranceDocumentsContainer /></div>
          </Col>
        </>
      }
       
    </>
  );
};
